import { render } from "./FormOwnershipView.vue?vue&type=template&id=b941d114"
import script from "./FormOwnershipView.vue?vue&type=script&lang=js"
export * from "./FormOwnershipView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__